import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { toast } from 'react-toastify'

import { Scope } from '@unform/core'
import {
  BotaoStep,
  FormRef,
  FormUnform,
  WizardContainer,
  SelectUnform,
  Checkbox,
  InputUnform,
  FuncoesMoeda,
  Informacao,
  scrollParaTopo,
  focarPrimeiroCampoComErro,
  SelectOpcao,
  IconeInformacao,
  Tooltip,
  Cores,
  CheckboxUnform,
  Botao,
  TelefoneInputUnform,
  CpfCnpjInputUnform,
  DataInputUnform
} from 'src/componentes'
import {
  SELECT_DIAS,
  SELECT_NACIONALIDADES,
  SELECT_PAISES,
  SELECT_TIPO_USUARIO
} from 'src/dados-estaticos'
import { ObterUsuarioDTO } from 'src/dto'
import { IconeLabel } from 'src/paginas/aluno/painel-financeiro/componentes/styles'
import { Api } from 'src/servicos'
import { enviarEventoGtm, trackMatricula } from 'src/servicos/analytics'
import { ObterDadosPrecificacaoPorCpf } from 'src/servicos/api'
import {
  CupomValido,
  FormaPagamentoCobranca,
  ResponsavelFinanceiro,
  TipoUsuario,
  Nacionalidade,
  PaisResidencia,
  PlanoPagamentoMatriculaForm,
  UsuarioSituacao
} from 'src/tipos'
import { PrecificacaoItem } from 'src/tipos/precificacao'
import { v4 } from 'uuid'

import MatriculaContainer from '../../container'
import {
  schemaPosGraduacaoPlanoPagamento,
  schemaPosGraduacaoPlanoPagamentoNovoResponsavelFinanceiro,
  schemaResponsavelFinanceiroPF
} from '../../schema'
import {
  ContainerConteudo,
  ContainerAcoes,
  ContainerCadastro,
  Linha,
  ContainerMedio,
  ContainerInfos,
  ContainerInfosPagamento,
  ContainerInputCupom,
  Info,
  TituloIsento,
  ContainerPossuiResponsavelFinanceiro,
  ContainerPequeno,
  ContainerGrande,
  ContainerCheio,
  CursoInfo
} from '../../styles'
import {
  ContainerOpcoes,
  ContainerValores,
  CupomContainer,
  Erro,
  OpcaoDados
} from './styles'

export const PlanoPagamento: React.FC = () => {
  const formRef = useRef<FormRef>(null)
  const formCupomRef = useRef<FormRef>(null)

  const {
    curso,
    matricula,
    definirPlanoPagamento,
    definirResponsavelFinanceiro,
    definirPasso
  } = MatriculaContainer.useContainer()
  const { mudarEtapa, voltarWizard, passo } = WizardContainer.useContainer()
  const [carregandoAvancar, definirCarregandoAvancar] = useState(false)
  const [carregandoVoltar, definirCarregandoVoltar] = useState(false)
  const [carregando, definirCarregando] = useState(false)
  const [carregandoPlanos, definirCarregandoPlanos] = useState(false)
  const [precificacao, definirPrecificacao] = useState<PrecificacaoItem>()
  const [temCupom, definirTemCupom] = useState(
    !!matricula.planoPagamento?.codigoCupom ?? true
  )
  const [cupom, definirCupom] = useState<CupomValido>(
    matricula.planoPagamento?.codigoCupom
      ? {
          cupomId: matricula.planoPagamento?.idCupom,
          codigoCupom: matricula.planoPagamento?.codigoCupom,
          valorDesconto: matricula.planoPagamento?.valorDesconto,
          valorFinal: matricula.planoPagamento?.valorTotal
        }
      : ({} as CupomValido)
  )
  const [listaPlanosPagamento, definirListaPlanosPagamento] = useState<
    {
      id: string
      valorParcelado?: number
      valorParcela?: number
      quantidadeParcelas?: number
      dataVencimento?: string | Date
    }[]
  >([])
  const [diaVencimento, definirDiaVencimento] = useState(
    matricula.planoPagamento?.diaVencimento ?? null
  )

  const [
    responsavelFinanceiro,
    definirResponsavelFinanceiroLocal
  ] = useState<ResponsavelFinanceiro>(
    matricula.responsavelFinanceiro ?? {
      possuiResponsavelFinanceiro: false
    }
  )

  const [
    tipoUsuarioResponsavelFinanceiro,
    definirTipoUsuarioResponsavelFinanceiro
  ] = useState<TipoUsuario>(
    matricula.responsavelFinanceiro?.usuarioResponsavel?.tipoUsuario
  )

  const [
    nacionalidadeResponsavelFinanceiro,
    definirNacionalidadeResponsavelFinanceiro
  ] = useState(Nacionalidade[Nacionalidade.brasileira])

  const [paisEndereco, definirPaisEndereco] = useState<string>(
    PaisResidencia.Brasil
  )

  const [
    usuarioResponsavelExistente,
    definirUsuarioResponsavelExistente
  ] = useState<ObterUsuarioDTO>(
    matricula?.responsavelFinanceiro?.usuarioResponsavel
      ? ({
          ...matricula?.responsavelFinanceiro?.usuarioResponsavel,
          endereco: null
        } as ObterUsuarioDTO)
      : null
  )

  const [
    enderecoResponsavelDiferente,
    definirEnderecoResponsavelDiferente
  ] = useState(false)

  const [
    formaPagamento,
    definirFormaPagamento
  ] = useState<FormaPagamentoCobranca>(null)

  const [formaPagamentoAlterada, definirFormaPagamentoAlterada] = useState(
    false
  )

  const [
    listaPlanoPagamentoSelect,
    definirListaPlanoPagamentoSelect
  ] = useState<Array<SelectOpcao>>([])

  const [codigoCupom, definirCodigoCupom] = useState<string>(
    matricula?.planoPagamento?.codigoCupom
  )

  const [
    planoPagamentoSelecionado,
    definirPlanoPagamentoSelecionado
  ] = useState<string>(null)

  const ehPagamentoRecorrente =
    formaPagamento === FormaPagamentoCobranca.Recorrente

  const opcoesPagamento = [
    {
      id: FormaPagamentoCobranca[FormaPagamentoCobranca.Boleto],
      texto: 'Boleto'
    },
    {
      id: FormaPagamentoCobranca[FormaPagamentoCobranca.CartaoCredito],
      texto: 'Cartão de crédito'
    },
    {
      id: FormaPagamentoCobranca[FormaPagamentoCobranca.Recorrente],
      texto: 'Recorrente'
    }
  ]

  const alterarCampoForm = (campo: string, valor: any, scope?: string) => {
    const nomeCampo = scope ? `${scope}.${campo}` : campo
    formRef?.current?.setFieldError(nomeCampo, null)
    formRef?.current?.setFieldValue(nomeCampo, valor)
  }

  useEffect(() => {
    const carregarPrecificacao = async () => {
      try {
        const dadosPrecificacao = await ObterDadosPrecificacaoPorCpf(
          matricula.dadosPessoais?.cpf
        )
        definirPrecificacao(dadosPrecificacao) // 👈 salva o retorno no estado
      } catch (e) {
        toast.error('Erro ao carregar plano de pagamento. Tente novamente.')
      }
    }
    carregarPrecificacao()
  }, [])

  // const formataData = (data: string | Date) => {
  //   let dataVencimentoFormatada: string | null = null
  //   if (data) {
  //     if (typeof data === 'string') {
  //       // Converte de dd/MM/yyyy para ISO
  //       const partes = data.split('/')
  //       if (partes.length === 3) {
  //         const [dia, mes, ano] = partes
  //         dataVencimentoFormatada = new Date(
  //           `${ano}-${mes}-${dia}`
  //         ).toISOString()
  //       }
  //     } else if (data instanceof Date) {
  //       dataVencimentoFormatada = data.toISOString()
  //     }
  //   }
  //   return dataVencimentoFormatada
  // }

  const planoSelecionado = listaPlanosPagamento?.find(
    p => p.id === planoPagamentoSelecionado
  )

  useEffect(() => {
    if (planoSelecionado?.dataVencimento) {
      formRef.current?.setFieldValue(
        'dataVencimentoRecorrente',
        planoSelecionado.dataVencimento
      )
    } else {
      formRef.current?.setFieldValue('dataVencimentoRecorrente', '')
    }
  }, [planoSelecionado])

  const dadosIniciais = useMemo(() => {
    if (matricula.planoPagamento) {
      return {
        formPagamentoParcela:
          matricula.planoPagamento.formPagamentoParcela ?? '',
        planoPagamentoId: matricula.planoPagamento.planoPagamentoId,
        diaVencimento: matricula.planoPagamento.diaVencimento,
        dataVencimentoRecorrente:
          matricula.planoPagamento.dataVencimentoRecorrente,
        responsavelFinanceiro:
          responsavelFinanceiro?.possuiResponsavelFinanceiro &&
          !!usuarioResponsavelExistente
            ? {
                email: usuarioResponsavelExistente.email,
                tipo: usuarioResponsavelExistente.tipoUsuario,
                nacionalidade: usuarioResponsavelExistente.nacionalidade,
                cpfCnpj:
                  usuarioResponsavelExistente.cpf ??
                  usuarioResponsavelExistente.cnpj,
                documentoIdentidade:
                  usuarioResponsavelExistente.documentoIdentidade ?? '',
                inscricaoEstadual:
                  usuarioResponsavelExistente.inscricaoEstadual,
                inscricaoMunicipal:
                  usuarioResponsavelExistente.inscricaoMunicipal,
                celular: usuarioResponsavelExistente.celular,
                nome: usuarioResponsavelExistente.nome
              }
            : {}
      }
    }

    return {
      formPagamentoParcela: '',
      planoPagamentoId: '',
      diaVencimento: ''
    }
  }, [
    matricula,
    responsavelFinanceiro,
    usuarioResponsavelExistente,
    precificacao
  ])

  const valorFormatado = useMemo(() => {
    return FuncoesMoeda.formatarMoeda(curso.precoBase ?? 0)
  }, [curso.precoBase])

  const valorDesconto = useMemo(() => cupom.valorDesconto ?? 0, [
    cupom.valorDesconto
  ])

  const valorDescontoFormatado = useMemo(
    () => FuncoesMoeda.formatarMoeda(valorDesconto),
    [valorDesconto]
  )

  const valorTotalOriginal = useMemo(() => {
    return matricula.planoPagamento?.valorParcelado ?? curso.precoBase
  }, [matricula.planoPagamento?.valorParcelado, curso.precoBase])

  // const valorDescontoParcelamento = useMemo(() => {
  //   if (!matricula.planoPagamento?.valorParcelado) return 0

  //   const valorParcelado = matricula.planoPagamento?.valorParcelado ?? 0

  //   const valorFinal = (curso.precoBase ?? 0) - valorParcelado

  //   return valorFinal < 0 ? 0 : valorFinal
  // }, [
  //   cupom?.valorDesconto,
  //   matricula.planoPagamento?.valorParcelado,
  //   curso.precoBase
  // ])

  const planoCarregado =
    matricula.planoPagamento?.valorParcelado != null &&
    matricula.planoPagamento?.quantidadeParcelas != null

  const valorParcela = useMemo(() => {
    const parcelaBruta = matricula.planoPagamento?.valorParcela ?? 0
    const quantidade = matricula.planoPagamento?.quantidadeParcelas ?? 0

    if (!parcelaBruta || !quantidade) return 0

    const descontoPorParcela = valorDesconto / quantidade

    return descontoPorParcela < parcelaBruta
      ? parcelaBruta - descontoPorParcela
      : 0
  }, [
    matricula.planoPagamento?.valorParcela,
    matricula.planoPagamento?.quantidadeParcelas,
    valorDesconto
  ])

  // O total precisa ser exatamente parcela x quantidade
  const valorTotal = useMemo(
    () => valorParcela * (matricula.planoPagamento?.quantidadeParcelas ?? 0),
    [valorParcela, matricula.planoPagamento?.quantidadeParcelas]
  )

  // const valorTotalFormatado = useMemo(
  //   () => FuncoesMoeda.formatarMoeda(valorTotal),
  //   [valorTotal]
  // )

  // const valorParcelaFormatado = useMemo(
  //   () => FuncoesMoeda.formatarMoeda(valorParcela),
  //   [valorParcela]
  // )

  const vencimentoEhMenorDataAtual = useMemo(() => {
    if (!diaVencimento || Number.isNaN(Number(diaVencimento))) {
      return false
    }

    return Number(diaVencimento) < new Date().getDate()
  }, [diaVencimento])

  const bloqueioCamposResponsavelFinanceiro = useMemo(
    () => carregando || !!usuarioResponsavelExistente,
    [carregando, usuarioResponsavelExistente]
  )

  const responsavelFinanceiroPf = useMemo(
    () => tipoUsuarioResponsavelFinanceiro === TipoUsuario.PF,
    [tipoUsuarioResponsavelFinanceiro]
  )

  const pfEstrangeiro = useMemo(
    () =>
      nacionalidadeResponsavelFinanceiro ===
        Nacionalidade[Nacionalidade.outra] && responsavelFinanceiroPf,
    [nacionalidadeResponsavelFinanceiro, responsavelFinanceiroPf]
  )

  const obterValorFormulario = (campo: string, scope?: string) => {
    const nomeCampo = scope ? `${scope}.${campo}` : campo

    return formRef?.current?.getFieldValue(nomeCampo)
  }

  const validarCupom = async ({ codigoCupom }: { codigoCupom?: string }) => {
    if (codigoCupom) {
      definirCodigoCupom(codigoCupom)
      trackMatricula.cupomPreenchido(codigoCupom)
      const novoCupom = await Api.RequisitarValidarCupom(
        matricula.id,
        codigoCupom,
        'PlanoPagamento',
        formaPagamento,
        planoPagamentoSelecionado
      )

      if (novoCupom) {
        definirCupom({ ...novoCupom, codigoCupom })
        trackMatricula.cupomAplicado(
          { valor_desconto: novoCupom.valorDesconto },
          codigoCupom
        )
      } else {
        definirCupom({} as CupomValido)
        // A API atual descarta a mensagem do back (retorna null em qualquer
        // erro), então o motivo granular ('limite_atingido') não chega aqui.
        trackMatricula.cupomRejeitado('nao_encontrado', codigoCupom)
      }

      formCupomRef.current?.setFieldError(
        'codigoCupom',
        novoCupom ? 'Cupom válido' : 'Cupom inválido'
      )
    } else {
      definirCupom({} as CupomValido)
      formCupomRef.current?.setFieldError('codigoCupom', '')
    }
  }

  const acaoSucesso = async (dados: PlanoPagamentoMatriculaForm) => {
    trackMatricula.planoPagamentoAvancarClicado()
    try {
      const possuiResponsavelFinanceiro =
        responsavelFinanceiro?.possuiResponsavelFinanceiro ?? false

      let responsavelFinanceiroPayload: ResponsavelFinanceiro = null

      if (possuiResponsavelFinanceiro) {
        const usuarioResponsavelForm = dados.responsavelFinanceiro
        const usuarioResponsavelFormPF =
          usuarioResponsavelForm.tipo === TipoUsuario.PF

        responsavelFinanceiroPayload = {
          possuiResponsavelFinanceiro,
          idUsuarioResponsavel: possuiResponsavelFinanceiro
            ? usuarioResponsavelExistente?.id
            : null,
          usuarioResponsavel:
            usuarioResponsavelForm && !usuarioResponsavelExistente?.id
              ? {
                  nome: usuarioResponsavelForm.nome,
                  email: usuarioResponsavelForm.email,
                  tipoUsuario: usuarioResponsavelForm.tipo,
                  cnpj: !usuarioResponsavelFormPF
                    ? usuarioResponsavelForm.cpfCnpj
                    : null,
                  cpf: usuarioResponsavelFormPF
                    ? usuarioResponsavelForm.cpfCnpj
                    : null,
                  nomeApresentacao: usuarioResponsavelForm.nome,
                  nacionalidade: usuarioResponsavelForm.nacionalidade,
                  situacao: UsuarioSituacao.Ativo,
                  senha: null,
                  perfis: [],
                  celular: usuarioResponsavelForm.celular,
                  documentoIdentidade: usuarioResponsavelFormPF
                    ? usuarioResponsavelForm.documentoIdentidade
                    : null,
                  inscricaoEstadual: !usuarioResponsavelFormPF
                    ? usuarioResponsavelForm.inscricaoEstadual
                    : null,
                  inscricaoMunicipal: !usuarioResponsavelFormPF
                    ? usuarioResponsavelForm.inscricaoMunicipal
                    : null,
                  endereco: enderecoResponsavelDiferente
                    ? {
                        ...usuarioResponsavelForm.endereco,
                        cep: usuarioResponsavelForm.endereco?.cep?.replaceAll(
                          '-',
                          ''
                        )
                      }
                    : null
                }
              : null,
          enderecoUsuarioMatricula: !enderecoResponsavelDiferente
        }
      }

      definirCarregandoAvancar(true)

      const responsavelEnviado = await Api.AvancarPlanoPagamentoOutrosCursos(
        matricula.id,
        {
          ...dados,
          idCupom: cupom.cupomId,
          pagamentoRecorrente: ehPagamentoRecorrente
        },
        responsavelFinanceiroPayload
      )
      definirPlanoPagamento({
        ...dados,
        responsavelFinanceiro: null,
        idCupom: cupom.cupomId,
        codigoCupom: cupom.codigoCupom,
        valorDesconto,
        valorParcelado: valorTotal,
        pagamentoRecorrente: ehPagamentoRecorrente,
        dataVencimentoRecorrente: planoSelecionado?.dataVencimento ?? null
      })

      const novoEstadoResponsavelFinanceiro = responsavelEnviado ?? {
        possuiResponsavelFinanceiro: false
      }

      definirResponsavelFinanceiro(novoEstadoResponsavelFinanceiro)

      trackMatricula.planoPagamentoConcluido({
        forma: formaPagamento,
        parcelas: matricula.planoPagamento?.quantidadeParcelas,
        tem_responsavel_financeiro: possuiResponsavelFinanceiro,
        tem_cupom: !!cupom.cupomId,
        dia_vencimento: dados.diaVencimento
      })
      trackMatricula.etapaConcluida('DadosPlanoPagamento')

      mudarEtapa(3)
      definirPasso(3)
    } catch (erro) {
      trackMatricula.planoPagamentoErro({
        status_http: (erro as { response?: { status?: number } })?.response
          ?.status,
        motivo: 'erro_servidor'
      })
      throw erro
    } finally {
      definirCarregandoAvancar(false)
    }

    const cursosGTM = []

    const cursoGTM = {
      id: v4(),
      name: curso.nome,
      category: curso.modalidade,
      price: valorTotal,
      coupon: cupom.codigoCupom,
      position: cursosGTM?.length + 1,
      metric1: cupom.valorDesconto ?? 0,
      metric2: curso.valorTaxaMatricula - cupom.valorDesconto,
      metric3: dados.diaVencimento
    }

    cursosGTM.push(cursoGTM)

    enviarEventoGtm({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            id: v4(),
            option: dados.formPagamentoParcela,
            step: 'Plano de Pagamento - Valor total do curso',
            revenue: valorTotal
          },
          products: cursosGTM
        }
      }
    })
  }

  useEffect(() => {
    scrollParaTopo()
  }, [passo])

  useEffect(() => {
    trackMatricula.etapaIniciada('DadosPlanoPagamento')
  }, []) //eslint-disable-line

  const buscarPlanosPagamento = async (nome: string) => {
    if (!formaPagamento) return
    try {
      definirCarregandoPlanos(true)
      const dados = await Api.RequisitarListaPlanosPagamento({
        idMatricula: matricula.id,
        nome: nome ?? '',
        idCupom: cupom.cupomId ?? undefined,
        formaPagamento: formaPagamento
      })

      if (!nome) {
        definirListaPlanosPagamento(dados)
        // Marco do sub-funil: viu (ou não) os planos. lista_vazia=true é o BUG
        // dos planos que somem — separa impedimento de desistência.
        trackMatricula.planosCarregados(formaPagamento, dados?.length ?? 0)
      }

      const dadosSelect = dados?.map(item => {
        const valorParcela = (item as { valorParcela?: number }).valorParcela
        return {
          id: item.id,
          texto: valorParcela
            ? `${item.texto} - ${FuncoesMoeda.formatarMoeda(
                valorParcela
              )}/parcela`
            : item.texto
        }
      })

      definirListaPlanoPagamentoSelect(dadosSelect ?? [])

      return dados
    } catch (erro) {
      trackMatricula.planosErro(
        formaPagamento,
        (erro as { response?: { status?: number } })?.response?.status
      )
      definirListaPlanoPagamentoSelect([])
    } finally {
      definirCarregandoPlanos(false)
    }
  }
  const definirDadosResponsavel = (dadosUsuario: ObterUsuarioDTO) => {
    if (!dadosUsuario) return

    definirTipoUsuarioResponsavelFinanceiro(dadosUsuario?.tipoUsuario)

    const scope = 'responsavelFinanceiro'

    alterarCampoForm('tipo', dadosUsuario?.tipoUsuario, scope)
    if (dadosUsuario?.tipoUsuario === TipoUsuario.PF) {
      alterarCampoForm(
        'documentoIdentidade',
        dadosUsuario?.documentoIdentidade ?? '',
        scope
      )

      alterarCampoForm('nacionalidade', dadosUsuario?.nacionalidade, scope)
    } else {
      alterarCampoForm(
        'inscricaoEstadual',
        dadosUsuario?.inscricaoEstadual,
        scope
      )
      alterarCampoForm(
        'inscricaoMunicipal',
        dadosUsuario?.inscricaoMunicipal,
        scope
      )
    }

    alterarCampoForm('nome', dadosUsuario?.nome, scope)

    const cpfCnpj = dadosUsuario?.cpf ?? dadosUsuario?.cnpj

    alterarCampoForm('cpfCnpj', cpfCnpj, scope)
    alterarCampoForm('email', dadosUsuario?.email, scope)

    alterarCampoForm('celular', dadosUsuario?.celular, scope)
  }

  const verificarExistenciaPorEmail = async () => {
    const scope = 'responsavelFinanceiro'
    const email = obterValorFormulario('email', scope)

    if (usuarioResponsavelExistente?.email === email) return
    try {
      definirCarregando(true)
      const usuarioResponsavelFinanceiro = await Api.VerificarUsuarioResponsavel(
        email
      )

      if (!usuarioResponsavelFinanceiro) {
        definirUsuarioResponsavelExistente(null)

        if (!tipoUsuarioResponsavelFinanceiro) {
          definirTipoUsuarioResponsavelFinanceiro(TipoUsuario.PF)
          alterarCampoForm('tipo', TipoUsuario.PF, scope)
        }

        return
      }

      definirUsuarioResponsavelExistente(usuarioResponsavelFinanceiro)

      definirDadosResponsavel(usuarioResponsavelFinanceiro)
    } catch (error) {
      definirUsuarioResponsavelExistente(null)
    } finally {
      definirCarregando(false)
    }
  }

  const verificarExistencia = async () => {
    const scope = 'responsavelFinanceiro'
    const cpfCnpj = obterValorFormulario('cpfCnpj', scope)

    if (
      usuarioResponsavelExistente?.cpf === cpfCnpj ||
      usuarioResponsavelExistente?.cnpj === cpfCnpj
    ) {
      return
    }

    try {
      definirCarregando(true)
      const usuarioResponsavelFinanceiro = responsavelFinanceiroPf
        ? await Api.VerificarUsuarioResponsavel(cpfCnpj)
        : await Api.VerificarUsuarioResponsavelPJ(cpfCnpj)

      if (!usuarioResponsavelFinanceiro) {
        definirUsuarioResponsavelExistente(null)
        return
      }

      definirUsuarioResponsavelExistente(usuarioResponsavelFinanceiro)

      definirDadosResponsavel(usuarioResponsavelFinanceiro)
    } catch (error) {
      definirUsuarioResponsavelExistente(null)
    } finally {
      definirCarregando(false)
    }
  }

  const buscarCep = async (cep: string) => {
    if (paisEndereco !== PaisResidencia.Brasil) {
      return
    }

    const endereco = await Api.BuscarCep(cep)
    const scope = 'responsavelFinanceiro.endereco'
    if (endereco) {
      alterarCampoForm('bairro', endereco.bairro, scope)
      alterarCampoForm('logradouro', endereco.logradouro, scope)
      alterarCampoForm('cidade', endereco.cidade, scope)
      alterarCampoForm('uf', endereco.uf, scope)
      alterarCampoForm('bairro', endereco.bairro, scope)
      alterarCampoForm('numero', endereco.numero, scope)
      alterarCampoForm('bairro', endereco.bairro, scope)

      document.getElementById('ipt_numero')?.focus()
    } else {
      alterarCampoForm('bairro', '', scope)
      alterarCampoForm('logradouro', '', scope)
      alterarCampoForm('cidade', '', scope)
      alterarCampoForm('uf', '', scope)
      alterarCampoForm('complemento', '', scope)
      alterarCampoForm('numero', '', scope)
    }
  }

  const schemaValido = useMemo(() => {
    if (
      responsavelFinanceiro?.possuiResponsavelFinanceiro &&
      !usuarioResponsavelExistente
    ) {
      return valorTotal > 0
        ? schemaPosGraduacaoPlanoPagamentoNovoResponsavelFinanceiro
        : schemaResponsavelFinanceiroPF
    }

    return valorTotal > 0 ? schemaPosGraduacaoPlanoPagamento : undefined
  }, [valorTotal, usuarioResponsavelExistente, responsavelFinanceiro])

  useEffect(() => {
    if (
      matricula?.planoPagamento.planoPagamentoId &&
      listaPlanoPagamentoSelect.length
    ) {
      alterarCampoForm(
        'planoPagamentoId',
        matricula?.planoPagamento.planoPagamentoId,
        null
      )
      return
    }
    alterarCampoForm('planoPagamentoId', null)
  }, [matricula.planoPagamento.planoPagamentoId, listaPlanoPagamentoSelect])

  const setFormaPagamentoEdicao = async selecionado => {
    definirFormaPagamentoAlterada(true)
    if (!selecionado) {
      await definirFormaPagamento(null)
    } else {
      const { id } = selecionado
      await definirFormaPagamento(FormaPagamentoCobranca[id])
    }
  }

  const deveLimparPlanoPagamento = useCallback(() => {
    const formaPagamentoMudou = formaPagamentoAlterada
    definirFormaPagamentoAlterada(false)
    return formaPagamentoMudou
  }, [formaPagamentoAlterada])

  useEffect(() => {
    if (formaPagamento) {
      trackMatricula.formaPagamentoSelecionada(formaPagamento)
    }
    definirPlanoPagamentoSelecionado(null)
    definirListaPlanoPagamentoSelect([])
    buscarPlanosPagamento(null)
    alterarCampoForm('diaVencimento', null)
    definirDiaVencimento(null)
  }, [formaPagamento])

  useEffect(() => {
    if (
      temCupom &&
      (formaPagamento === FormaPagamentoCobranca.Boleto ||
        formaPagamento === FormaPagamentoCobranca.Recorrente ||
        formaPagamento === FormaPagamentoCobranca.CartaoCredito) &&
      listaPlanoPagamentoSelect.length > 0 &&
      planoPagamentoSelecionado
    ) {
      validarCupom({ codigoCupom })
    }
  }, [formaPagamento, planoPagamentoSelecionado, listaPlanoPagamentoSelect])
  const infoBoleto =
    'Nesta forma de pagamento, mensalmente você deve entrar em seu portal e realizar o pagamento via boleto ou cartão de crédito da parcela do mês vigente.'
  const infoRecorrente =
    'Nesta forma de pagamento, você irá cadastrar o seu cartão de crédito na nossa plataforma parceira CIELO e o pagamento será descontado mensalmente de forma automática, comprometendo apenas o limite da parcela do mês vigente.'
  const infoCartao =
    'Nesta forma de pagamento, é comprometido o limite total do valor a ser pago, porém parcelada na quantidade de parcelas escolhidas.'
  // eslint-disable-next-line
  const informacaoPagamento = formaPagamento === FormaPagamentoCobranca.Boleto ? infoBoleto : formaPagamento === FormaPagamentoCobranca.Recorrente ? infoRecorrente : FormaPagamentoCobranca.CartaoCredito ? infoCartao : ''

  return (
    <ContainerConteudo>
      <h2>Resumo do Curso</h2>
      <ContainerCadastro>
        <FormUnform
          ref={formRef}
          schema={schemaValido}
          dadosIniciais={dadosIniciais}
          acaoSucesso={acaoSucesso}
          acaoFalha={(errors: Record<string, string>) => {
            trackMatricula.validacaoErro('DadosPlanoPagamento', errors)
            focarPrimeiroCampoComErro()
          }}
        >
          <ContainerValores>
            <ContainerInfosPagamento>
              <ContainerInfos>
                <CursoInfo>
                  {!!curso?.cargaHoraria && (
                    <p>{`Carga Horária: ${curso?.cargaHoraria}h`}</p>
                  )}
                  {!!curso?.duracao && (
                    <p>{`Duração: ${curso?.duracao} ${
                      curso?.duracao > 1 ? 'meses' : 'mês'
                    }`}</p>
                  )}
                </CursoInfo>
                <Info negrito>
                  <p>
                    Valor do Curso <sup>1 2</sup>
                  </p>
                  <p>{valorFormatado}</p>
                </Info>
              </ContainerInfos>
              <ContainerInfos>
                <Info>
                  <Informacao
                    invertido
                    id="informacao-tcc-nao-incluso"
                    textoTooltip="O TCC é opcional. Para realizar, o aluno deve informar ao núcleo acadêmico após ingresso no curso, e será cobrada uma taxa adicional de R$ 500,00 (parcelada em até 3x) no início das orientações do mesmo."
                  >
                    <sup>1</sup> Taxa de TCC não incluso
                  </Informacao>
                </Info>
                <Info>
                  <Informacao
                    invertido
                    id="informacao-valor-taxa-matricula"
                    textoTooltip="O valor da taxa de matrícula não está vinculado ao total do curso, pois refere-se a encargos administrativos. A confirmação do mesmo, garante sua vaga no curso. O pagamento da taxa de matrícula será realizado na última etapa deste processo."
                  >
                    <sup>2</sup> Valor da taxa de matrícula não incluso
                  </Informacao>
                </Info>
              </ContainerInfos>
            </ContainerInfosPagamento>
          </ContainerValores>
          {/* Só afirma isenção com o plano já carregado: sem plano o total é 0 por
              falta de dados, não porque não há o que pagar. */}
          {!carregandoPlanos && planoCarregado && valorTotal <= 0 && (
            <TituloIsento>ISENTO: Não há parcelas a pagar.</TituloIsento>
          )}
          <ContainerOpcoes>
            <Linha>
              <ContainerMedio>
                <SelectUnform
                  id="slct_formPagamentoParcela"
                  name="formPagamentoParcela"
                  label={
                    <>
                      Forma de Pagamento
                      <IconeLabel
                        data-tip={informacaoPagamento}
                        data-for="tooltip-forma-pagamento"
                      >
                        {IconeInformacao}
                      </IconeLabel>
                    </>
                  }
                  placeholder="Selecione"
                  valorAlterado={setFormaPagamentoEdicao}
                  obrigatorio
                  opcoes={opcoesPagamento}
                />
                <Tooltip
                  id="tooltip-forma-pagamento"
                  place="right"
                  className="tooltip-ipgs"
                  textColor={Cores.PRETO}
                  backgroundColor={Cores.CINZA_1_CLARO}
                />
              </ContainerMedio>
              <ContainerMedio>
                <SelectUnform
                  key={'slc_plano_pagamento'}
                  id="slc_plano_pagamento"
                  name="planoPagamentoId"
                  label="Selecione o Plano de Pagamento do Curso"
                  obrigatorio
                  opcoes={listaPlanoPagamentoSelect}
                  carregando={carregandoPlanos}
                  deveLimpar={deveLimparPlanoPagamento}
                  disabled={!formaPagamento}
                  valorAlterado={valor => {
                    definirPlanoPagamentoSelecionado(valor?.id)
                    if (listaPlanosPagamento?.length > 0) {
                      let valorParcelado: number = null
                      let valorParcela: number = null
                      let quantidadeParcelas: number = null
                      let dataVencimento: string | Date = null

                      if (valor) {
                        const opcaoSelecionada = listaPlanosPagamento.find(
                          item => item.id === valor?.id
                        )
                        valorParcelado = opcaoSelecionada?.valorParcelado
                        valorParcela = opcaoSelecionada?.valorParcela
                        quantidadeParcelas =
                          opcaoSelecionada?.quantidadeParcelas
                        dataVencimento = opcaoSelecionada?.dataVencimento

                        trackMatricula.planoSelecionado({
                          forma: formaPagamento,
                          parcelas: opcaoSelecionada?.quantidadeParcelas,
                          valor_parcela: opcaoSelecionada?.valorParcela
                        })

                        valorParcelado = valorParcelado ?? null
                        valorParcela = valorParcela ?? null
                        quantidadeParcelas = quantidadeParcelas ?? null
                        dataVencimento = dataVencimento ?? null

                        if (
                          opcaoSelecionada?.id !==
                          matricula?.planoPagamento?.planoPagamentoId
                        ) {
                          definirPlanoPagamento({
                            ...matricula.planoPagamento,
                            valorParcelado,
                            valorParcela,
                            quantidadeParcelas,
                            dataVencimentoRecorrente: dataVencimento
                          })
                        }
                      } else {
                        definirPlanoPagamento({
                          ...matricula.planoPagamento,
                          valorParcelado,
                          valorParcela,
                          quantidadeParcelas,
                          dataVencimentoRecorrente: dataVencimento
                        })
                      }
                    }
                  }}
                />
              </ContainerMedio>
            </Linha>
            <Linha>
              <ContainerMedio>
                {planoSelecionado?.dataVencimento ? (
                  <DataInputUnform
                    name="dataVencimentoRecorrente"
                    label="Dia de Vencimento para a Parcela"
                    disabled={true}
                  />
                ) : (
                  <>
                    <SelectUnform
                      id="slc_dia_vencimento"
                      name="diaVencimento"
                      label="Selecione o Dia de Vencimento Desejado para a Parcela"
                      placeholder="Selecione"
                      obrigatorio={!ehPagamentoRecorrente}
                      disabled={ehPagamentoRecorrente}
                      margemInferior={false}
                      opcoes={SELECT_DIAS}
                      valorAlterado={opcao => {
                        if (opcao && opcao.id) {
                          definirDiaVencimento(opcao.id)
                          trackMatricula.diaVencimentoSelecionado(opcao.id)
                        }
                      }}
                    />
                    {vencimentoEhMenorDataAtual && (
                      <Erro>
                        Atenção! Como a data de vencimento escolhida já passou,
                        o seu primeiro vencimento ficará para o último dia útil
                        deste mês.
                      </Erro>
                    )}
                  </>
                )}
              </ContainerMedio>
            </Linha>
            <Linha style={{ marginTop: '15px', marginBottom: '15px' }}>
              <ContainerMedio>
                {valorTotalOriginal > 0 && (
                  <Checkbox
                    texto={
                      <>
                        Tenho um cupom
                        <IconeLabel
                          style={{ marginLeft: '20px' }}
                          data-tip="Antes de habilitar o cupom é necessário selecionar o número de parcelas."
                          data-for="tooltip-forma-pagamento"
                        >
                          {IconeInformacao}
                        </IconeLabel>
                      </>
                    }
                    htmlFor="chk_tem_cupom"
                    tamanho="L"
                  >
                    <input
                      type="checkbox"
                      id="chk_tem_cupom"
                      checked={temCupom}
                      disabled={
                        !planoPagamentoSelecionado ||
                        planoPagamentoSelecionado === null
                      }
                      onChange={() => {
                        definirTemCupom(old => {
                          trackMatricula.cupomMarcado(!old)
                          return !old
                        })
                        definirCupom({} as CupomValido)
                      }}
                    />
                  </Checkbox>
                  // eslint-disable-next-line indent
                )}
              </ContainerMedio>
              {temCupom ? (
                <ContainerMedio>
                  <ContainerInputCupom>
                    <FormUnform
                      dadosIniciais={{
                        codigoCupom: cupom?.codigoCupom || ''
                      }}
                      ref={formCupomRef}
                      acaoSucesso={validarCupom}
                      acaoFalha={focarPrimeiroCampoComErro}
                    >
                      <CupomContainer>
                        {/* Validar cupom antes do plano carregar calcularia o
                            desconto sobre dados incompletos. */}
                        <InputUnform
                          id="ipt_cupom"
                          name="codigoCupom"
                          sucesso={!!cupom.cupomId}
                          disabled={carregandoPlanos || !planoCarregado}
                          onBlur={event => {
                            if (carregandoPlanos || !planoCarregado) return

                            definirCodigoCupom(event.target.value)
                            formCupomRef.current?.submitForm()
                          }}
                          placeholder="Código do cupom"
                        />
                        <Botao
                          id="btn_validar_cupom"
                          type="button"
                          disabled={carregandoPlanos || !planoCarregado}
                          onClick={() => {
                            formCupomRef.current?.submitForm()
                          }}
                          texto="Validar"
                        />
                      </CupomContainer>
                    </FormUnform>
                  </ContainerInputCupom>
                </ContainerMedio>
              ) : (
                <></>
              )}
            </Linha>
            <Linha style={{ marginBottom: '10px' }}>
              {formaPagamento === FormaPagamentoCobranca.Recorrente && (
                <ContainerGrande>
                  <ContainerInputCupom>
                    <OpcaoDados>
                      <Informacao
                        invertido
                        id="informacao-pagamento-recorrente"
                        textoTooltip="Nesta forma de pagamento, você irá cadastrar o seu cartão de crédito na nossa plataforma parceira CIELO e o pagamento será descontado mensalmente de forma automática, comprometendo apenas o limite da parcela do mês vigente."
                      >
                        <CheckboxUnform
                          id="chk_pagamento_recorrente"
                          name="chkPagamentoRecorrente"
                          texto="Pagamento Recorrente"
                          checked={ehPagamentoRecorrente}
                        ></CheckboxUnform>
                      </Informacao>
                    </OpcaoDados>
                  </ContainerInputCupom>
                </ContainerGrande>
              )}
            </Linha>
            <Linha>
              <ContainerMedio>
                {/* Enquanto os planos carregam (ou antes de um ser escolhido) os
                    valores em tela seriam calculados sobre dados incompletos e
                    exibiriam números que não correspondem a plano nenhum. */}
                {!carregandoPlanos && planoCarregado && (
                  <>
                    <Info style={{ marginBottom: '10px' }}>
                      <p>
                        Descontos totais <sup>3</sup>
                      </p>
                      <p>{valorDescontoFormatado}</p>
                    </Info>
                    <Info style={{ marginBottom: '10px' }}>
                      <p>Valor da parcela: </p>
                      {matricula.planoPagamento.quantidadeParcelas !== null &&
                        matricula.planoPagamento.valorParcela > 0 && (
                          <p style={{ fontWeight: 500, fontSize: '18px' }}>
                            {matricula.planoPagamento.quantidadeParcelas}x de
                          </p>
                          // eslint-disable-next-line indent
                        )}
                      <p>{FuncoesMoeda.formatarMoeda(valorParcela)}</p>
                    </Info>
                    <Info negrito style={{ marginTop: '20px' }}>
                      <p style={{ fontSize: '18px' }}>Valor total a pagar </p>
                      <p style={{ fontSize: '18px' }}>
                        {FuncoesMoeda.formatarMoeda(valorTotal)}
                      </p>
                    </Info>
                  </>
                )}
                {/* </ContainerMedio> */}
              </ContainerMedio>
              <ContainerMedio>
                <Info>
                  <Informacao
                    invertido
                    id="informacao-cartao-recorrencia"
                    semIcone
                  >
                    <div style={{ width: '280px', display: 'inline-block' }}>
                      <sup>3</sup> Descontos totais: Este valor corresponde à
                      soma de cupons de desconto aplicadose e eventuais
                      arredondamentos de valores.
                    </div>
                  </Informacao>
                </Info>
              </ContainerMedio>
            </Linha>
            {/* </ContainerInfosPagamento> */}
            <Linha style={{ marginTop: '30px' }}>
              <ContainerPossuiResponsavelFinanceiro>
                <Checkbox
                  onClick={e => e.stopPropagation()}
                  texto={
                    <>
                      Possui Responsável Financeiro
                      <IconeLabel
                        style={{ marginLeft: '30px' }}
                        data-tip="Selecione caso deseje cobrança e nota fiscal em nome de terceiros."
                        data-for="tooltip-forma-pagamento"
                        onClick={e => e.stopPropagation()}
                      >
                        {IconeInformacao}
                      </IconeLabel>
                    </>
                  }
                  htmlFor="chk_possui_responsavel_financeiro"
                  tamanho="L"
                >
                  <input
                    type="checkbox"
                    id="chk_possui_responsavel_financeiro"
                    checked={
                      responsavelFinanceiro?.possuiResponsavelFinanceiro ??
                      false
                    }
                    onClick={e => e.stopPropagation()}
                    onChange={() => {
                      definirResponsavelFinanceiroLocal(old => {
                        const possui = !old.possuiResponsavelFinanceiro
                        trackMatricula.responsavelFinanceiroMarcado(possui)
                        if (!possui) {
                          definirUsuarioResponsavelExistente(null)
                        }
                        return {
                          ...old,
                          possuiResponsavelFinanceiro: possui,
                          usuarioResponsavel: !possui
                            ? old.usuarioResponsavel
                            : null
                        }
                      })
                    }}
                  />
                </Checkbox>
              </ContainerPossuiResponsavelFinanceiro>
              {/* </ContainerMedio> */}
            </Linha>
            <Scope path="responsavelFinanceiro">
              {responsavelFinanceiro?.possuiResponsavelFinanceiro && (
                <>
                  <Linha>
                    <ContainerMedio>
                      <InputUnform
                        id="ipt_email_responsavel_financeiro"
                        name="email"
                        label="E-mail"
                        obrigatorio
                        disabled={bloqueioCamposResponsavelFinanceiro}
                        onBlur={verificarExistenciaPorEmail}
                      />
                    </ContainerMedio>
                    <ContainerMedio>
                      <SelectUnform
                        id="slc_tipo_responsavel_financeiro"
                        name="tipo"
                        opcoes={SELECT_TIPO_USUARIO}
                        label={'Tipo Responsável Financeiro'}
                        disabled={bloqueioCamposResponsavelFinanceiro}
                        valorAlterado={valor => {
                          if (valor) {
                            definirTipoUsuarioResponsavelFinanceiro(
                              TipoUsuario[valor.id]
                            )
                            trackMatricula.rfTipoSelecionado(
                              valor.id === TipoUsuario[TipoUsuario.PJ]
                                ? 'PJ'
                                : 'PF'
                            )
                          } else {
                            definirTipoUsuarioResponsavelFinanceiro(null)
                          }
                        }}
                      />
                    </ContainerMedio>
                  </Linha>
                  {tipoUsuarioResponsavelFinanceiro && (
                    <>
                      <>
                        <Linha>
                          {responsavelFinanceiroPf && (
                            <ContainerPequeno>
                              <SelectUnform
                                id="slc_nacionalidade_responsavel"
                                name="nacionalidade"
                                label="Nacionalidade"
                                placeholder="Selecione"
                                obrigatorio={
                                  !bloqueioCamposResponsavelFinanceiro
                                }
                                opcoes={SELECT_NACIONALIDADES}
                                disabled={bloqueioCamposResponsavelFinanceiro}
                                valorAlterado={valor => {
                                  definirNacionalidadeResponsavelFinanceiro(
                                    valor?.id
                                  )
                                }}
                              />
                            </ContainerPequeno>
                          )}
                          {!pfEstrangeiro && (
                            <ContainerPequeno>
                              <CpfCnpjInputUnform
                                id="ipt_cpf_responsavel_financeiro"
                                name="cpfCnpj"
                                label={responsavelFinanceiroPf ? 'CPF' : 'CNPJ'}
                                obrigatorio={
                                  !bloqueioCamposResponsavelFinanceiro
                                }
                                disabled={bloqueioCamposResponsavelFinanceiro}
                                onBlur={verificarExistencia}
                              />
                            </ContainerPequeno>
                          )}

                          {responsavelFinanceiroPf ? (
                            <ContainerPequeno>
                              <InputUnform
                                id="ipt_documento_identidade"
                                name="documentoIdentidade"
                                label="Documento de Identidade"
                                obrigatorio={
                                  !bloqueioCamposResponsavelFinanceiro
                                }
                                disabled={bloqueioCamposResponsavelFinanceiro}
                                maxLength={20}
                                bloquearCaracteresEspeciais
                              />
                            </ContainerPequeno>
                          ) : (
                            <>
                              <ContainerPequeno>
                                <InputUnform
                                  id="ipt_inscricao_estadual"
                                  name="inscricaoEstadual"
                                  label="Inscrição Estadual"
                                  obrigatorio={
                                    !bloqueioCamposResponsavelFinanceiro
                                  }
                                  disabled={bloqueioCamposResponsavelFinanceiro}
                                  maxLength={20}
                                />
                              </ContainerPequeno>
                              <ContainerPequeno>
                                <InputUnform
                                  id="ipt_inscricao_municipal"
                                  name="inscricaoMunicipal"
                                  label="Inscrição Municipal"
                                  disabled={bloqueioCamposResponsavelFinanceiro}
                                  maxLength={20}
                                />
                              </ContainerPequeno>
                            </>
                          )}
                          <ContainerPequeno>
                            <TelefoneInputUnform
                              id="ipt_celular_responsavel_financeiro"
                              name="celular"
                              label="Celular"
                              obrigatorio={!bloqueioCamposResponsavelFinanceiro}
                              disabled={bloqueioCamposResponsavelFinanceiro}
                            />
                          </ContainerPequeno>
                        </Linha>
                      </>

                      <Linha>
                        <ContainerCheio>
                          <InputUnform
                            id="ipt_nome_responsavel_financeiro"
                            name="nome"
                            label={
                              responsavelFinanceiroPf
                                ? 'Nome Completo'
                                : 'Razão Social'
                            }
                            obrigatorio={!bloqueioCamposResponsavelFinanceiro}
                            disabled={bloqueioCamposResponsavelFinanceiro}
                            maxLength={200}
                            style={{ textTransform: 'uppercase' }}
                          ></InputUnform>
                        </ContainerCheio>
                      </Linha>
                      {!usuarioResponsavelExistente && (
                        <>
                          <Linha>
                            <ContainerPossuiResponsavelFinanceiro>
                              <CheckboxUnform
                                id="chk_reaproveitar_endereco"
                                texto="O endereço do Responsável Financeiro é diferente do meu endereço"
                                tamanho="L"
                                name="enderecoDiferente"
                                onChange={() => {
                                  definirEnderecoResponsavelDiferente(old => {
                                    trackMatricula.rfEnderecoDiferente(!old)
                                    return !old
                                  })
                                }}
                                checked={enderecoResponsavelDiferente}
                              ></CheckboxUnform>
                            </ContainerPossuiResponsavelFinanceiro>
                          </Linha>
                          {enderecoResponsavelDiferente && (
                            <Scope path="endereco">
                              <Linha>
                                <>
                                  <ContainerPequeno>
                                    <SelectUnform
                                      id="slc_pais"
                                      name="pais"
                                      label="País"
                                      placeholder="Selecione"
                                      obrigatorio
                                      opcoes={SELECT_PAISES}
                                      valorAlterado={opcao =>
                                        definirPaisEndereco(
                                          opcao ? opcao.id : ''
                                        )
                                      }
                                    />
                                  </ContainerPequeno>
                                </>
                                <ContainerPequeno>
                                  <InputUnform
                                    id="ipt_cep"
                                    name="cep"
                                    label="CEP"
                                    obrigatorio={
                                      paisEndereco === PaisResidencia.Brasil
                                    }
                                    mascara="99999-999"
                                    onBlur={event =>
                                      buscarCep(event.target.value)
                                    }
                                  />
                                </ContainerPequeno>
                              </Linha>
                              <Linha>
                                <ContainerGrande>
                                  <InputUnform
                                    id="ipt_logradouro"
                                    name="logradouro"
                                    label="Logradouro"
                                    obrigatorio
                                    maxLength={200}
                                  />
                                </ContainerGrande>
                                <ContainerPequeno>
                                  <InputUnform
                                    id="ipt_numero"
                                    name="numero"
                                    label="Número"
                                    obrigatorio
                                    maxLength={10}
                                  />
                                </ContainerPequeno>
                              </Linha>
                              <Linha>
                                <ContainerMedio>
                                  <InputUnform
                                    id="ipt_complemento"
                                    name="complemento"
                                    label="Complemento"
                                    maxLength={200}
                                  />
                                </ContainerMedio>
                                <ContainerMedio>
                                  <InputUnform
                                    id="ipt_bairro"
                                    name="bairro"
                                    label="Bairro"
                                    obrigatorio
                                    maxLength={200}
                                  />
                                </ContainerMedio>
                              </Linha>
                              <Linha>
                                <ContainerMedio>
                                  <InputUnform
                                    id="ipt_cidade"
                                    name="cidade"
                                    label="Cidade"
                                    obrigatorio
                                    maxLength={200}
                                  />
                                </ContainerMedio>
                                <ContainerMedio>
                                  <InputUnform
                                    id="ipt_uf"
                                    name="uf"
                                    label="UF"
                                    obrigatorio
                                  />
                                </ContainerMedio>
                              </Linha>
                            </Scope>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Scope>
          </ContainerOpcoes>
          <ContainerAcoes>
            <BotaoStep
              invertido
              texto="Voltar para"
              textoNegrito="Dados Pessoais"
              tema="Secundario"
              type="button"
              disabled={carregandoVoltar}
              onClick={() => {
                definirCarregandoVoltar(true)
                voltarWizard()
              }}
            />
            <BotaoStep
              texto="Ir para"
              textoNegrito="Termos e Condições"
              carregando={carregandoAvancar}
              type="submit"
            />
          </ContainerAcoes>
        </FormUnform>
      </ContainerCadastro>
    </ContainerConteudo>
  )
}
